/**
 * @GENERATED from Figma node 3608:51012
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#2684FC"
      d="M22 12.222c0-.822-.068-1.422-.215-2.044h-9.58v3.71h5.623c-.113.923-.726 2.312-2.086 3.245l-.02.125 3.03 2.3.21.02C20.889 17.833 22 15.267 22 12.222"
    />
    <path
      fill="#00AC47"
      d="M12.205 22c2.755 0 5.068-.889 6.757-2.422l-3.22-2.445c-.862.59-2.018 1-3.538 1A6.13 6.13 0 0 1 6.4 13.978l-.12.01-3.15 2.389-.041.112C4.767 19.756 8.214 22 12.205 22"
    />
    <path
      fill="#FFBA00"
      d="M6.399 13.978A6 6 0 0 1 6.06 12c0-.689.125-1.356.329-1.978l-.006-.132-3.19-2.428-.104.049A9.85 9.85 0 0 0 2 12c0 1.611.397 3.133 1.088 4.489z"
    />
    <path
      fill="#EA4335"
      d="M12.205 5.867c1.916 0 3.208.81 3.945 1.489L19.03 4.6C17.26 2.989 14.96 2 12.204 2 8.215 2 4.767 4.244 3.09 7.511l3.3 2.511a6.16 6.16 0 0 1 5.815-4.155"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleDark);
export { ForwardRef as GoogleDark };
